import Service from './service';

export default class Settings extends Service {
  baseApi = '/system-settings';

  async getPercentage() {
    const url = `${this.baseApi}`;
    return await this.getResource(url);
  }

  async postPercentage(body) {
    const url = `${this.baseApi}`;
    return await this.postResource(url, body);
  }
}
